if (!customElements.get('timeline-immersive')) {
  customElements.define(
    'timeline-immersive',
    class TimelineImmersive extends window.BAO.CustomElement {
      constructor () {
        super()
      }

      connectedCallback () {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.activeCardIndex = 0

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)

        this.updateEl()

        this.carousel = this.initialiseCarousel()
      }

      setupListeners () {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })

        this.els.trigger.elements.forEach(triggerEl => {
          triggerEl.addEventListener('click', this.handleTrigger.bind(this))
        })

        this.els.previous.element.addEventListener(
          'click',
          this.handlePrevious.bind(this)
        )
        this.els.next.element.addEventListener(
          'click',
          this.handleNext.bind(this)
        )
      }

      onScroll () {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick () {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl () {
        this.isTicking = false

        this.handleScroll()
      }

      handleScroll () {
        if (window.innerWidth < 901) return

        const panelEls = this.querySelectorAll(
          '[data-timeline-immersive-el="panel"]'
        )
        const progressEl = this.querySelector(
          '[data-timeline-immersive-el="progress"]'
        )

        const maxItems = panelEls.length - 1

        const containerOffsetTop = getOffsetTop(this)
        const elementStartPoint = containerOffsetTop
        const elementEndPoint =
          elementStartPoint + this.offsetHeight - window.innerHeight

        if (this.lastKnownY <= elementStartPoint) {
          this.setActiveCard(0)

          progressEl.style.setProperty('--Progress', `0%`)

          return
        }

        if (this.lastKnownY > elementEndPoint) {
          this.setActiveCard(maxItems)
          progressEl.style.setProperty('--Progress', `100%`)

          return
        }

        const totalScrollAmount = elementEndPoint - elementStartPoint

        const scrollYAsAPercentageOfJourney =
          (this.lastKnownY - elementStartPoint) / totalScrollAmount

        const progressAmount = scrollYAsAPercentageOfJourney * 100

        progressEl.style.setProperty(
          '--Progress',
          `${progressAmount.toFixed(2)}%`
        )

        panelEls.forEach((panelEl, index) => {
          const minimumPercent = index / panelEls.length
          const maximumPercent = (index + 1) / panelEls.length
          const isWithinRange =
            scrollYAsAPercentageOfJourney >= minimumPercent &&
            scrollYAsAPercentageOfJourney < maximumPercent

          if (isWithinRange) {
            this.setActiveCard(index)

            return
          }
        })
      }

      setActiveCard (activeCardIndex) {
        if (activeCardIndex === this.activeCardIndex) return

        const triggerEls = this.querySelectorAll(
          '[data-timeline-immersive-el="trigger"]'
        )
        const panelEls = this.querySelectorAll(
          '[data-timeline-immersive-el="panel"]'
        )
        const mediaEls = this.querySelectorAll(
          '[data-timeline-immersive-el="media"]'
        )

        this.activeCardIndex = activeCardIndex

        triggerEls.forEach(triggerEl => {
          triggerEl.classList.toggle(
            'sec-TimelineImmersive_Trigger-active',
            triggerEl.dataset.index === this.activeCardIndex.toString()
          )
        })

        panelEls.forEach(panelEl => {
          panelEl.setAttribute(
            'aria-hidden',
            panelEl.dataset.index !== this.activeCardIndex.toString()
          )
        })

        mediaEls.forEach(mediaEl => {
          mediaEl.setAttribute(
            'aria-hidden',
            mediaEl.dataset.index !== this.activeCardIndex.toString()
          )
        })
      }

      handleTrigger (event) {
        const triggerIndex = parseInt(event.target.dataset.index)

        if (window.innerWidth < 901) {
          this.carousel.moveToIdx(triggerIndex)
        } else {
          const panelEls = this.querySelectorAll(
            '[data-timeline-immersive-el="panel"]'
          )
          const totalPanels = panelEls.length

          const containerOffsetTop = getOffsetTop(this)
          const containerHeight = this.offsetHeight - window.innerHeight

          const singlePanelHeight = containerHeight / totalPanels
          const indexPanelOffset = singlePanelHeight * triggerIndex

          const scrollToPosition =
            containerOffsetTop + indexPanelOffset + singlePanelHeight / 2

          window.scrollTo(0, scrollToPosition)
        }
      }

      initialiseCarousel () {
        if (!this.els.panel?.exists) return

        this.onSlideChanged = this.onSlideChanged.bind(this)
        this.handleButtonState = this.handleButtonState.bind(this)

        return new window.KeenSlider685(this.els.panels.element, {
          selector: this.els.panel.selector,
          loop: false,
          renderMode: 'custom',
          created: this.handleButtonState,
          slideChanged: this.onSlideChanged,
          breakpoints: {
            '(min-width: 901px)': {
              disabled: true
            }
          }
        })
      }

      handlePrevious () {
        this.carousel.prev()
      }
      handleNext () {
        this.carousel.next()
      }

      onSlideChanged (instance) {
        const currentSlide = instance.track.details.rel
        const totalSlides = instance.track.details.length

        this.setActiveCard(currentSlide)

        const progressEl = this.querySelector(
          '[data-timeline-immersive-el="progress"]'
        )

        const progressAmount = (currentSlide / totalSlides) * 100

        progressEl.style.setProperty(
          '--Progress',
          `${progressAmount.toFixed(2)}%`
        )

        this.handleButtonState(instance)
      }

      handleButtonState (instance) {
        const nextEl = this.querySelector('[data-timeline-immersive-el="next"]')
        const previousEl = this.querySelector(
          '[data-timeline-immersive-el="previous"]'
        )

        if (nextEl) {
          nextEl.disabled =
            instance.track.details.abs === instance.track.details.maxIdx
          nextEl.setAttribute(
            'aria-hidden',
            instance.track.details.maxIdx === 0
          )
        }

        if (previousEl) {
          previousEl.disabled =
            instance.track.details.abs === instance.track.details.min
          previousEl.setAttribute(
            'aria-hidden',
            instance.track.details.maxIdx === 0
          )
        }
      }
    }
  )
}
